<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="采购组织" label-width="80px">
                        <el-select v-model="dataForm.purOrg" filterable placeholder="请选择组织">
                            <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgCode+'_'+item.purchaseOrgName" :value="item.purchaseOrgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input clearable size="mini" v-model="dataForm.venderCode"  style="width: 150px " placeholder="供应商代码" @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input clearable size="mini" v-model="dataForm.venderName"  style="width: 150px " placeholder="供应商名称" @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="年度分类" label-width="80px">
                        <el-cascader v-model="yearTypes" :options="YEAR_TYPE_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                    </el-form-item>
                   <el-form-item label="评价年度" label-width="80px">
                       <el-select v-model="dataForm.year1" clearable placeholder="请选择">
                          <el-option v-for="item in year1List" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                       </el-select>
                       至
                       <el-select v-model="dataForm.year2" clearable placeholder="请选择">
                          <el-option v-for="item in year2List" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                       </el-select>
                   </el-form-item>
                    <el-form-item label="供应商分类" label-width="100px">
                        <el-cascader v-model="classTypes" :options="CLASS_TYPE_VALUE" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                    </el-form-item>
                    <el-form-item class="fr">
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:0px">查询
                        </el-button>
                        <el-button size="mini" @click="exportData()" icon="el-icon-plus">导出</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="tableHeight" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column align="center" v-model="something" type="selection" width="50">
            </el-table-column>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="purOrg" header-align="center" align="center" label="采购组织代码" min-width="80">
                <template slot-scope="scope">
                    {{ scope.row.purOrg }}
                </template>
            </el-table-column>
            <el-table-column prop="desc" header-align="center" align="left" label="绩效评价名称" min-width="180">
                <template slot-scope="scope">
                     {{ scope.row.evaName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="center" label="供应商代码" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="center" label="供应商名称" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.venderName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="center" label="供应商简称" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="total" header-align="center" align="center" label="供应商得分" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.total }}
                </template>
            </el-table-column>
            <el-table-column prop="no" header-align="center" align="center" label="排名" min-width="50" >
                <template slot-scope="scope">
                    {{ scope.row.no }}
                </template>
            </el-table-column>
            <el-table-column prop="classType" header-align="center" align="center" label="供应商分类" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.classType }}
                </template>
            </el-table-column>
            <el-table-column  align="center"label="质量">
                <el-table-column prop="sckkx" align="center" :label="'市场可靠性质量\n(6分)'" width="70">
                </el-table-column>
                <el-table-column prop="rclbj" :label="'入厂零部件质量\n(10分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="scgc" :label="'生产过程质量\n(18分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="lbjzl" :label="'零部件质量改进\n(6分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="成本">
                <el-table-column prop="jcbyj" align="center" :label="'降成本业绩\n(10分)'" width="70">
                </el-table-column>
                <el-table-column prop="pjjgsp" :label="'平均价格水平\n(5分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="swphd" :label="'商务配合度\n(5分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="交付">
                <el-table-column prop="lbjgh" align="center" :label="'零部件供货\n(10分)'" width="70">
                </el-table-column>
                <el-table-column prop="ghfw" :label="'供货服务\n(10分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="服务">
                <el-table-column prop="xcfwzc" align="center" :label="'现场服务支持\n(3分)'" width="70">
                </el-table-column>
                <el-table-column prop="shpjjf" :label="'售后配件交付\n(4分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="shfwxysd" :label="'售后服务响应速度\n(3分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="开发">
                <el-table-column prop="xcpkfph" align="center" :label="'新产品开发配合\n(5分)'" width="70">
                </el-table-column>
                <el-table-column prop="xpkfyj" :label="'新品开发业绩\n(5分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
    </div>
</template>
<script>
import {
    getSupplierEvaList,importSupplierEva,exportSupplierEvaData
} from '@/controller/supplier'
import {
    getPurchaseOrgList
} from '@/controller/systemData'
import {
    YEAR_TYPE_VALUE,
    CLASS_TYPE_VALUE,
    USER_TYPE,
} from "@/utils/const";
    export default {
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                dataForm: {
                    key: '',
                    year1: new Date().getFullYear(),
                    yearTypes: [],
                    classTypes: [],
                    venderName: '',
                    venderCode: '',
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                options1: [{
                        value: '0',
                        label: '新建'
                    }, {
                        value: '1',
                        label: '已发布'
                    }
                ],
                purchaseOrgList: [],
                yearTypes: [],
                classTypes: [],
                YEAR_TYPE_VALUE: YEAR_TYPE_VALUE,
                year1List: [],
                year2List: [],
                CLASS_TYPE_VALUE: CLASS_TYPE_VALUE,
                USER_TYPE: USER_TYPE,
            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 260
                }
            }
        },
        activated() {
            this.getDataList()
        },
        created() {
            this.getYearList()
            // 采购组织
            this.getPurchaseOrgList()
        },
        mounted() {

        },
        methods: {

            dateFormat: function (row, column) {
              var date = row[column.property]
              if (!date) {
                  return ''
              }
              return moment(date).format("YYYY-MM-DD HH:mm:ss")
            },
        
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                var pYear1 = this.dataForm.year1
                var pYear2 = this.dataForm.year2
                if(pYear1 > pYear2) {
                    this.$message.warning("评价年度1不能大于评价年度2！")
                    return
                }
                this.dataListLoading = true
                this.dataForm.yearTypes = []
                this.yearTypes.forEach(yearType => {
                    this.dataForm.yearTypes.push(yearType[0])
                })
                this.dataForm.classTypes = []
                this.classTypes.forEach(classType => {
                    this.dataForm.classTypes.push(classType[0])
                })
                getSupplierEvaList({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'purOrg': this.dataForm.purOrg,
                    'venderCode': this.dataForm.venderCode,
                    'venderName': this.dataForm.venderName,
                    'evaTypes': this.dataForm.yearTypes,
                    'evaYear1': this.dataForm.year1,
                    'evaYear2': this.dataForm.year2,
                    'classTypes': this.dataForm.classTypes,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                console.log(val)
                this.dataListSelections = val
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },

            //关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },

            // 导出供应商绩效
            exportData () {
                const params = {
                    'purOrg': this.dataForm.purOrg,
                    'venderCode': this.dataForm.venderCode,
                    'venderName': this.dataForm.venderName,
                    'evaTypes': this.dataForm.yearTypes,
                    'evaYear1': this.dataForm.year1,
                    'evaYear2': this.dataForm.year2,
                    'classTypes': this.dataForm.classTypes
                }
                exportSupplierEvaData(params).then((data) => {
                    if(data && data.code == '00') {
                        this.readAsBinaryString(data.body)
                    } else {
                        this.$message.error(data.msg)
                    }
                }).catch((e) => {
                    console.log(e)
                })
            },
            readAsBinaryString(data) {
                // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
                // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
                let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
                dom.style.display = 'none';
                dom.href = url;
                dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
                document.body.appendChild(dom);
                dom.click();
            },
            str2Blob(str, mime) {
                var arr = str.split(',')
                var bstr = atob(arr[0]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            // 下拉输入采购组织
            getPurchaseOrgList() {
                getPurchaseOrgList({
                    purchaseOrgCode: "",
                    purchaseOrgName: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        this.purchaseOrgList = data.body;
                    }
                });
            },
           //获得评价年度
           getYearList() {
               var date = new Date();
               var year = date.getFullYear()
               for(var i = 2020; i <= year; i++) {
                   var obj = {"value" : i, "label" : i}
                   this.year1List.push(obj);
                   this.year2List.push(obj);
               }
           },
        }
    }
</script>

<style lang="scss">
    .fr { float: right; }

    .button-danger { color: #F56C6C; }
</style>